import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { USER_PROFILE_PATH } from '../../constants';
import { RoleType } from '../domain/module-role';
import { AppSelector } from '../store';

export const roleGuard =
	(): CanActivateFn => async (activatedRoute: ActivatedRouteSnapshot) => {
		const accountSelector = inject(AppSelector);
		const router = inject(Router);

		const requiredRoles: Array<RoleType> = activatedRoute.data['roles'] || [];

		const connectedUser = await firstValueFrom(
			accountSelector.getConnectedUser$(),
		);

		const rolesInOrganization = connectedUser.accounts.get(
			connectedUser.primaryOrganizationId,
		);
		const userHasAtLeastOneRole =
			connectedUser &&
			rolesInOrganization &&
			requiredRoles.some((role) => rolesInOrganization.includes(role));
		if (userHasAtLeastOneRole) {
			return true;
		} else {
			return router.parseUrl(USER_PROFILE_PATH);
		}
	};
